import { Action } from 'redux';
import { Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { LOAD_INTERNAL_MARKETER, LoadInternalMarketer } from '../../../actions/marketer/internal/loadInternalMarketer';
import {
    UpdateInternalMarketer,
    updateInternalMarketerAction
} from '../../../actions/marketer/internal/updateInternalMarketer';
import {
    UpdateInternalMarketerPageStatus,
    updateInternalMarketerPageStatusAction
} from '../../../actions/marketer/internal/updateInternalMarketerPageStatus';
import {
    UpdateInternalProductPlaces,
    updateInternalProductPlacesAction
} from '../../../actions/places/internal/updateInternalProductPlaces';
import {
    UpdateInternalProducts,
    updateInternalProductsAction
} from '../../../actions/products/internal/updateInternalProducts';
import { selectProductsSortParams } from '../../../selectors/products';
import { EpicDeps } from '../../../service/StoreFactory';
import { MarketersPageStates } from '../../../typings/marketers';
import { State } from '../../../typings/state';

type EpicActions =
    | UpdateInternalMarketer
    | UpdateInternalMarketerPageStatus
    | UpdateInternalProductPlaces
    | UpdateInternalProducts;

export const loadInternalMarketerEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) =>
    action$.pipe(
        ofType(LOAD_INTERNAL_MARKETER),
        mergeMap(
            (action: LoadInternalMarketer): Observable<EpicActions> => {
                return from(
                    Promise.all([
                        deps.productsDataProvider.getPlaces(),
                        deps.productsDataProvider.getList(),
                        deps.marketersDataProvider.getMarketer(action.id)
                    ])
                ).pipe(
                    mergeMap(([places, products, marketer]) => {
                        const productsSortParams = selectProductsSortParams(store$.value);

                        return of(
                            updateInternalProductPlacesAction(places),
                            updateInternalProductsAction(products),
                            updateInternalMarketerAction(marketer, productsSortParams),
                            updateInternalMarketerPageStatusAction(MarketersPageStates.LOADED)
                        );
                    }),
                    catchError(() => of(updateInternalMarketerPageStatusAction(MarketersPageStates.ERROR)))
                );
            }
        )
    );
